import {
  CartActionTypes,
  CartState,
  ADD_CART,
  FETCH_CART,
  DELETE_ITEM_CART,
  UPDATE_CART,
  FETCH_CLIENT,
  CHECKOUT_CART,
  LOADING_CART,
  RESET_ALERT_MESSAGE_CART,
  FETCH_SHIPPING_COST,
  RESET_SHIPPING_COST,
  RESET_CLIENT,
} from "../actions/types";

const initialState: CartState = {
  cart: [],
  totalCart: 0,
  itemsCart: 0,
  minimumCart: 0,
  alertMessage: null,
  payways: [],
  client: null,
  addressPickup: null,
  incrementSale: 5,
  messageFinish: null,
  frequentUserCoupon: null,
  isLoading: false,
  shippingCost: 0,
  discountCashShop: 0,
  provinces: [
    {
      id: 1,
      name: "CABA",
    },
    {
      id: 2,
      name: "Buenos Aires",
    },
    {
      id: 3,
      name: "Catamarca",
    },
    {
      id: 4,
      name: "Chaco",
    },
    {
      id: 5,
      name: "Chubut",
    },
    {
      id: 6,
      name: "Córdoba",
    },
    {
      id: 7,
      name: "Corrientes",
    },
    {
      id: 8,
      name: "Entre Ríos",
    },
    {
      id: 9,
      name: "Formosa",
    },
    {
      id: 10,
      name: "Jujuy",
    },
    {
      id: 11,
      name: "La Pampa",
    },
    {
      id: 12,
      name: "La Rioja",
    },
    {
      id: 13,
      name: "Mendoza",
    },
    {
      id: 14,
      name: "Misiones",
    },
    {
      id: 15,
      name: "Neuquen",
    },
    {
      id: 16,
      name: "Río Negro",
    },
    {
      id: 17,
      name: "Salta",
    },
    {
      id: 18,
      name: "San Juan",
    },
    {
      id: 19,
      name: "San Luis",
    },
    {
      id: 20,
      name: "Santa Cruz",
    },
    {
      id: 21,
      name: "Santa Fe",
    },
    {
      id: 22,
      name: "Santiago del Estero",
    },
    {
      id: 23,
      name: "Tierra del Fuego",
    },
    {
      id: 24,
      name: "Tucumán",
    },
  ],
};

const cartReducer = (state = initialState, action: CartActionTypes) => {
  switch (action.type) {
    case ADD_CART:
      return {
        ...state,
        cart: action.payload.cart,
        totalCart: action.payload.totalCart,
        itemsCart: action.payload.itemsCart,
        minimumCart: action.payload.minimumCart,
        alertMessage: action.payload.alertMessage,
        isLoading: false,
      };
    case FETCH_CART:
      return {
        ...state,
        cart: action.payload.cart,
        totalCart: action.payload.totalCart,
        itemsCart: action.payload.itemsCart,
        minimumCart: action.payload.minimumCart,
        frequentUserCoupon: action.payload.frequentUserCoupon,
        discountCashShop: action.payload.discountCashShop || 0,
        isLoading: false,
      };
    case DELETE_ITEM_CART:
      return {
        ...state,
        cart: action.payload.cart,
        totalCart: action.payload.totalCart,
        itemsCart: action.payload.itemsCart,
        minimumCart: action.payload.minimumCart,
        isLoading: false,
      };
    case UPDATE_CART:
      return {
        ...state,
        cart: action.payload.cart,
        totalCart: action.payload.totalCart,
        itemsCart: action.payload.itemsCart,
        minimumCart: action.payload.minimumCart,
        alertMessage: action.payload.alertMessage,
        isLoading: false,
      };
    case FETCH_CLIENT:
      return {
        ...state,
        totalCart: action.payload.totalCart,
        payways: action.payload.payways,
        client: action.payload.client,
        alertMessage: action.payload.alertMessage,
        addressPickup: action.payload.addressPickup,
        incrementSale: action.payload.incrementSale,
        isLoading: false,
      };
    case CHECKOUT_CART:
      return {
        ...state,
        cart: [],
        totalCart: 0,
        itemsCart: 0,
        minimumCart: 0,
        alertMessage: null,
        payways: [],
        client: null,
        incrementSale: 5,
        messageFinish: action.payload.messageFinish,
        isLoading: false,
      };
    case LOADING_CART:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SHIPPING_COST:
      return {
        ...state,
        isLoading: false,
        shippingCost: action.payload.shippingCost,
      };
    case RESET_ALERT_MESSAGE_CART:
      return {
        ...state,
        alertMessage: initialState.alertMessage,
      };
    case RESET_SHIPPING_COST:
      return {
        ...state,
        shippingCost: initialState.shippingCost,
      };
    case RESET_CLIENT:
      return {
        ...state,
        client: null,
      };
    default:
      return state;
  }
};

export default cartReducer;
